const getTenantPrefix = () => {
  const tenantId = localStorage.getItem('tenantId');
  return process.env.NODE_ENV !== 'development' && tenantId ? tenantId + '/' : '';
};

const getHubPath = () => {
  const tenantPrefix = getTenantPrefix();
  return `/api/${tenantPrefix}dashboardHub`;
};

export { getHubPath, getTenantPrefix };
